export enum DrawerPlacement {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right'
}
